import atomize from "@quarkly/atomize";
export default atomize.img({
  name: "Image",
  effects: {
    hover: ":hover"
  },
  normalize: true,
  mixins: true,
  description: {
    en: "Image element — image",
    ru: "Элемент image — изображение"
  },
  propInfo: {
    src: {
      weight: 1,
      control: "image",
      category: "Main",
      description: {
        en: "src — image address",
        ru: "src — aдрес изображения"
      }
    },
    alt: {
      weight: 1,
      type: "string",
      category: "Main"
    },
    title: {
      weight: 1,
      type: "string",
      category: "Main"
    }
  }
}, {
  "min-width": "16px",
  "min-height": "16px",
  display: "inline-block"
});